import { Box, CircularProgress, Grid, Stack, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import GetSiteRec from '../../../components/api/GetSiteRec';
import DataUnavailable from '../../../components/data/DataUnavailable';
import { useNavigate, useParams } from 'react-router-dom';
import { useDate } from '../../../components/datepicker/DateContext';
import { useSite } from '../../../components/siteselector/SiteContext';
import DatePicker from '../../../components/datepicker/DatePicker';
import { tokens } from '../../../theme';
import TimelineIcon from '@mui/icons-material/Timeline';
import BoltIcon from '@mui/icons-material/Bolt';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import SkySparkGrid from '../../../components/api/SkySparkGrid';
import { WeekDayChart } from '../../../components/charts/ems/';
import LoginCookieAuth from '../../../components/api/LoginCookieAuth';
import Cookies from 'js-cookie';
import GetUser from '../../../components/api/GetUser';

function PerformancetrendScene() {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [siteName, setSiteName] = useState("");
    const [, setSiteRec] = useState({});
    const [lineData, setLineData] = useState([]);
    const { selectedSite } = useSite();
    const { selectedDate } = useDate();
    const { siteId } = useParams();
    const navigate = useNavigate();
    const [lineValid, setLineValid] = useState(false);
    const [lineLoading, setLineLoading] = useState(true);
    const [pageAcces, SetPageAcces] = useState(false)

    useEffect(() => {
        GetUser().then((response) => {
            const pageWhitelist = response.data["rows"][0].infSiteModules
            if (pageWhitelist.includes('ems/performancetrend')) SetPageAcces(true)
            else navigate('/projects')
        })
        LoginCookieAuth(Cookies.get('skyarc-auth-8080')).then(async (authResponse) => {
            if (authResponse) {
                SkySparkGrid(`testElec(@${siteId}, ${selectedDate[0].dateString})`).then((response) => {
                    if (response.data["rows"].length === 0 || response.data["meta"]["sampleCount"] === 0) {
                        setLineValid(false)
                        setLineLoading(false)
                    } else {
                        setLineValid(true)
                        const responseVal = response.data["rows"]
                        setLineData((<WeekDayChart dataValues={responseVal} />))
                        setLineLoading(false)
                    }
                })

                if (siteId !== "undefined") {
                    GetSiteRec(siteId).then((response) => {
                        const responseVal = response.data["rows"][0]
                        setSiteRec(responseVal)
                        setSiteName(responseVal["navName"])
                    })
                }

                //scroll after navigating
            }
            document.getElementById('content').scrollTo(0, 0)
        })
    }, [navigate, siteId, siteName, selectedSite, selectedDate]);
    return (
        <>
            {
                pageAcces ? (
                    <Box m="18px" maxWidth="100%">
                        {/* TOP ROW - BUTTONS*/}
                        <Box display="grid" sx={{display:'flex'}}>
                            <DatePicker />
                        </Box>

                        {/* Grid Container */}
                        <Grid container gap={2} direction={{ xl: "row" }} wrap="nowrap" height='100%' sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', marginTop:'-28px' }}>
                            <Grid item xl={12}>
                                <Stack spacing={2}>
                                    {/* Weii Chart */}
                                    <Typography fontSize={20} textAlign='center' color={colors.greenAccent[500]} fontWeight='bold'>WEii</Typography>
                                    <Box backgroundColor={colors.primary[400]} sx={{ minHeight: '250px', minWidth: { xl: '1256px', lg: '1000px' } }}>
                                        <Grid container wrap="nowrap" height="100%" direction={{ xl: 'row', lg: 'column', md: 'column', sm: 'column', xs: 'column' }}>
                                            <Grid item xl={1}>
                                                <Box backgroundColor={colors.greenAccent[500]} height="100%" display='flex'>
                                                    <TimelineIcon sx={{ width: '70px', height: '70px', margin: 'auto' }} />
                                                </Box>
                                            </Grid>
                                            <Grid item xl={6}>
                                                <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '350px', width: '99%' }}>
                                                    {
                                                        lineLoading ? (<CircularProgress style={{ 'color': 'gray', opacity: '0.5' }} />) : (lineValid ? lineData : <DataUnavailable />)
                                                    }
                                                </Box>
                                            </Grid>
                                            <Grid item xl={5}>
                                                <Box p={5}>
                                                    <Typography fontSize={14} textAlign='left' color={colors.greenAccent[500]} fontWeight='bold'>
                                                        Doel
                                                    </Typography>
                                                    <Typography fontSize={12} textAlign='left'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut aliquet at nunc vel pretium. Duis arcu odio, rhoncus et orci eget, laoreet fermentum quam</Typography>
                                                    <br />
                                                    <Typography fontSize={14} textAlign='left' color={colors.greenAccent[500]} fontWeight='bold'>
                                                        KPI - WEII
                                                    </Typography>
                                                    <Typography fontSize={12} textAlign='left'>Nulla ac aliquam nisi. Integer lacinia sed nisi ut sodales. Nulla sit amet urna sed enim cursus commodo posuere eget sem. Aenean sit amet magna enim. Sed ac elit finibus, interdum tellus id, feugiat ex. Ut aliquet ipsum ut ipsum gravida, et molestie orci porttitor. Ut lacus nisi, condimentum et scelerisque tempus, finibus sit amet ligula.</Typography>
                                                    <br />
                                                    <Typography fontSize={14} textAlign='left' color={colors.greenAccent[500]} fontWeight='bold'>
                                                        Gebruikersoppervlakte(m²)
                                                    </Typography>
                                                    <Typography fontSize={12} textAlign='left'>Nulla ac aliquam nisi. Integer lacinia sed nisi ut sodales. Nulla sit amet urna sed enim cursus commodo posuere eget sem. Aenean sit amet magna enim. Sed ac elit finibus, interdum tellus id, feugiat ex. Ut aliquet ipsum ut ipsum gravida, et molestie orci porttitor. Ut lacus nisi, condimentum et scelerisque tempus, finibus sit amet ligula.</Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Typography fontSize={20} textAlign='center' color={colors.greenAccent[500]} fontWeight='bold'>Elektraverbruik</Typography>
                                    <Box backgroundColor={colors.primary[400]} sx={{ minHeight: '250px', minWidth: { xl: '1256px', lg: '1000px' } }}>
                                        <Grid container wrap="nowrap" height="100%" direction={{ xl: 'row', lg: 'column', md: 'column', sm: 'column', xs: 'column' }}>
                                            <Grid item xl={1}>
                                                <Box backgroundColor={colors.greenAccent[500]} height="100%" display='flex'>
                                                    <BoltIcon sx={{ width: '70px', height: '70px', margin: 'auto' }} />
                                                </Box>
                                            </Grid>
                                            <Grid item xl={6}>
                                                <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '350px', width: '99%' }}>
                                                    {
                                                        lineLoading ? (<CircularProgress style={{ 'color': 'gray', opacity: '0.5' }} />) : (lineValid ? lineData : <DataUnavailable />)
                                                    }
                                                </Box>
                                            </Grid>
                                            <Grid item xl={5}>
                                                <Box p={5}>
                                                    <Typography fontSize={14} textAlign='left' color={colors.greenAccent[500]} fontWeight='bold'>
                                                        Doel
                                                    </Typography>
                                                    <Typography fontSize={12} textAlign='left'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut aliquet at nunc vel pretium. Duis arcu odio, rhoncus et orci eget, laoreet fermentum quam</Typography>
                                                    <br />
                                                    <Typography fontSize={14} textAlign='left' color={colors.greenAccent[500]} fontWeight='bold'>
                                                        KPI - Elektra
                                                    </Typography>
                                                    <Typography fontSize={12} textAlign='left'>Nulla ac aliquam nisi. Integer lacinia sed nisi ut sodales. Nulla sit amet urna sed enim cursus commodo posuere eget sem. Aenean sit amet magna enim. Sed ac elit finibus, interdum tellus id, feugiat ex. Ut aliquet ipsum ut ipsum gravida, et molestie orci porttitor. Ut lacus nisi, condimentum et scelerisque tempus, finibus sit amet ligula.</Typography>
                                                    <br />
                                                    <Typography fontSize={14} textAlign='left' color={colors.greenAccent[500]} fontWeight='bold'>
                                                        Buitentempratuur
                                                    </Typography>
                                                    <Typography fontSize={12} textAlign='left'>Nulla ac aliquam nisi. Integer lacinia sed nisi ut sodales. Nulla sit amet urna sed enim cursus commodo posuere eget sem. Aenean sit amet magna enim. Sed ac elit finibus, interdum tellus id, feugiat ex. Ut aliquet ipsum ut ipsum gravida, et molestie orci porttitor. Ut lacus nisi, condimentum et scelerisque tempus, finibus sit amet ligula.</Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Typography fontSize={20} textAlign='center' color={colors.greenAccent[500]} fontWeight='bold'>Gasverbruik</Typography>
                                    <Box backgroundColor={colors.primary[400]} sx={{ minHeight: '250px', minWidth: { xl: '1256px', lg: '1000px' } }}>
                                        <Grid container wrap="nowrap" height="100%" direction={{ xl: 'row', lg: 'column', md: 'column', sm: 'column', xs: 'column' }}>
                                            <Grid item xl={1}>
                                                <Box backgroundColor={colors.greenAccent[500]} height="100%" display='flex'>
                                                    <LocalFireDepartmentIcon sx={{ width: '70px', height: '70px', margin: 'auto' }} />
                                                </Box>
                                            </Grid>
                                            <Grid item xl={6}>
                                                <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '350px', width: '99%' }}>
                                                    {
                                                        lineLoading ? (<CircularProgress style={{ 'color': 'gray', opacity: '0.5' }} />) : (lineValid ? lineData : <DataUnavailable />)
                                                    }
                                                </Box>
                                            </Grid>
                                            <Grid item xl={5}>
                                                <Box p={5}>
                                                    <Typography fontSize={14} textAlign='left' color={colors.greenAccent[500]} fontWeight='bold'>
                                                        Doel
                                                    </Typography>
                                                    <Typography fontSize={12} textAlign='left'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut aliquet at nunc vel pretium. Duis arcu odio, rhoncus et orci eget, laoreet fermentum quam</Typography>
                                                    <br />
                                                    <Typography fontSize={14} textAlign='left' color={colors.greenAccent[500]} fontWeight='bold'>
                                                        KPI - Gas
                                                    </Typography>
                                                    <Typography fontSize={12} textAlign='left'>Nulla ac aliquam nisi. Integer lacinia sed nisi ut sodales. Nulla sit amet urna sed enim cursus commodo posuere eget sem. Aenean sit amet magna enim. Sed ac elit finibus, interdum tellus id, feugiat ex. Ut aliquet ipsum ut ipsum gravida, et molestie orci porttitor. Ut lacus nisi, condimentum et scelerisque tempus, finibus sit amet ligula.</Typography>
                                                    <br />
                                                    <Typography fontSize={14} textAlign='left' color={colors.greenAccent[500]} fontWeight='bold'>
                                                        Buitentempratuur
                                                    </Typography>
                                                    <Typography fontSize={12} textAlign='left'>Nulla ac aliquam nisi. Integer lacinia sed nisi ut sodales. Nulla sit amet urna sed enim cursus commodo posuere eget sem. Aenean sit amet magna enim. Sed ac elit finibus, interdum tellus id, feugiat ex. Ut aliquet ipsum ut ipsum gravida, et molestie orci porttitor. Ut lacus nisi, condimentum et scelerisque tempus, finibus sit amet ligula.</Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Box>
                ) : (
                    null
                )
            }
        </>
    )
}

export default PerformancetrendScene
